import { Component, Input } from '@angular/core';
import { ImageModel } from '../../model/image.model';

@Component({
  selector: 'app-report-image',
  templateUrl: './report-image.component.html',
  styleUrls: ['./report-image.component.scss']
})
export class ReportImageComponent {

  @Input()
  reportImage: ImageModel;

  constructor() {
  }
}
